import {Record, List} from 'immutable';

import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import Name from '../common/name';
import Image from '../common/image';
import Contact from '../contacts/model';
import * as Types from './types';

const KeyWorker = Record({
    employeeId: '',
    image: '',
    name: Name.default,
    status,
});

const keyWorkerFromAPI = keyWorker =>
    new KeyWorker({
        ...keyWorker,
        name: Name.fromAPI(keyWorker.name),
    });

export const kikuChildFromApi = kikuChild => new Types.KikuChild(kikuChild);

export const keyWorkersFromAPI = keyWorkers => (keyWorkers ? List(keyWorkers.map(keyWorkerFromAPI)) : List());

function genderValue(gender) {
    let genderValue = 0;
    if (gender === 'Dreng') {
        genderValue = 1;
    } else if (gender === 'Pige') {
        genderValue = 2;
    }
    return genderValue;
}

function fromAPI(data) {
    return new Types.Child({
        ...data,
        id: data.childId,
        tagIds: List(data.tagIds),
        keyWorkers: keyWorkersFromAPI(data.keyWorkers),
        relations: data.relations ? List(data.relations.map(relation => Contact.fromAPI(relation))) : List(),
        behaviors: new BehaviorsCollection(data.behaviors),
        name: Name.fromAPI(data.name),
        image: Image.fromAPI(data.image),
        genderValue: genderValue(data.gender),
        conversation: data.conversation ? new Types.Conversation(data.conversation) : new Types.Conversation(),
        statusRegistrations: List(data.statusRegistrations),
        isExpected: Boolean(
            data.attending && data.attending.from && data.attending.to && !data.isSick && !data.hasVacation,
        ),
        mealRegistrations: List(data.mealRegistrations),
    });
}

export default {
    record: Types.Child,
    default: new Types.Child(),
    fromAPI,
    keyWorkersFromAPI,
    kikuChildFromApi,
};
